import React from 'react'
import Helmet from 'react-helmet'
import compact from 'lodash/compact'

const Head = ({
  title,
  description,
  keywords,
  author,
  ogType,
  ogTitle,
  ogDescription,
  ogImage = {},
  ogUrl = {},
  url = {},
  favicon = {},
  appleTouchIcon = {},
  customStylesheets = [],
  customScripts = [],
  customStyles
}) => {
  const tags = [
    title && <title key='title'>{title}</title>,
    description && <meta key='meta-description' name='description' content={description} />,
    keywords && <meta key='meta-keywords' name='keywords' content={keywords} />,
    author && <meta key='meta-author' name='author' content={author} />,
    ogType && <meta key='meta-og-type' property='og:type' content={ogType} />,
    ogTitle && <meta key='meta-og-title' property='og:title' content={ogTitle} />,
    ogDescription && <meta key='meta-og-description' property='og:description' content={ogDescription} />,
    ogImage.url && <meta key='meta-og-image' property='og:image' content={ogImage.url} />,
    ogUrl.url && <meta key='meta-og-url' property='og:url' content={ogUrl.url} />,
    url.url && <link key='rel-canonical' rel='canonical' href={url.url} />,
    favicon.url && <link key='rel-shortcut-icon' rel='shortcut icon' href={favicon.url} />,
    appleTouchIcon.url && <link key='rel-apple-touch-icon' rel='apple-touch-icon' href={appleTouchIcon.url} />,
    customStyles && <style key='custom-styles' type='text/css'>{customStyles}</style>,
    ...customStylesheets.map((link, key) => link.url && <link key={key} rel='stylesheet' href={link.url} />),
    ...customScripts.map((script, key) => script.url && <script {...(script.async === 'yes' ? { async: true } : {})} key={key} type='text/javascript' src={script.url} />)
  ]

  return (
    <Helmet>
      {compact(tags)}
    </Helmet>
  )
}

export default Head



// WEBPACK FOOTER //
// ./components/utils/Head/index.js